"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var errorHandler = require('../js/errors.js').handleError;

var search = {
  state: {
    capitalTypesParam: [],
    providerTypesParam: [],
    sectorsParam: [],
    countriesParam: [],
    loadingResults: false,
    results: [],
    range: [],
    maxResults: null,
    resultsPerPage: null,
    femaleFocusParam: false,
    numResultsLoaded: 0
  },
  getters: {
    getNumResults: function getNumResults(state) {
      return state.numResultsLoaded;
    },
    getSelectedCapitalTypes: function getSelectedCapitalTypes(state) {
      return state.capitalTypesParam.map(function (item) {
        return item.name;
      });
    },
    getSelectedProviderTypes: function getSelectedProviderTypes(state) {
      return state.providerTypesParam.map(function (item) {
        return item.name;
      });
    },
    getSelectedCountries: function getSelectedCountries(state) {
      return state.countriesParam.map(function (item) {
        return item.name;
      });
    },
    getSelectedSectors: function getSelectedSectors(state) {
      return state.sectorsParam.map(function (item) {
        return item.name;
      });
    },
    isLoadingResults: function isLoadingResults(state) {
      return state.loadingResults;
    },
    // check param selected
    capitalTypeSelected: function capitalTypeSelected(state) {
      return function (capitalType) {
        return state.capitalTypesParam.indexOf(capitalType.code) > -1;
      };
    },
    providerTypeSelected: function providerTypeSelected(state) {
      return function (providerType) {
        return state.providerTypesParam.indexOf(providerType.code) > -1;
      };
    },
    countrySelected: function countrySelected(state) {
      return function (country) {
        return state.countriesParam.indexOf(country.code) > -1;
      };
    },
    sectorSelected: function sectorSelected(state) {
      return function (sector) {
        return state.sectorsParam.indexOf(sector.code) > -1;
      };
    },
    femaleFocusSelected: function femaleFocusSelected(state) {
      return state.femaleFocusParam;
    },
    // results
    results: function results(state) {
      return state.results;
    },
    currentResults: function currentResults(state) {
      return state.results.filter(function (result, index) {
        return index >= state.range[0] && index < state.range[1];
      });
    },
    isFirstPage: function isFirstPage(state) {
      return state.range[0] <= 0;
    },
    isLastPage: function isLastPage(state) {
      return state.range[1] >= state.results.length;
    },
    maxResults: function maxResults(state) {
      return state.maxResults;
    },
    resultsPerPage: function resultsPerPage(state) {
      return state.resultsPerPage;
    }
  },
  mutations: {
    setNumResults: function setNumResults(state, data) {
      state.numResultsLoaded = data;
    },
    setCapitalTypesParam: function setCapitalTypesParam(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (data == undefined) {
        state.capitalTypesParam = [];
      } else {
        state.capitalTypesParam = [data.code];
      }
    },
    setProviderTypesParam: function setProviderTypesParam(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (data == undefined) {
        state.providerTypesParam = [];
      } else {
        state.providerTypesParam = [data.code];
      }
    },
    setCountriesParam: function setCountriesParam(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (data == undefined) {
        state.countriesParam = [];
      } else {
        state.countriesParam = [data.code];
      }
    },
    setSectorsParam: function setSectorsParam(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      if (data == undefined) {
        state.sectorsParam = [];
      } else {
        state.sectorsParam = [data.code];
      }
    },
    setFemaleFocusParam: function setFemaleFocusParam(state, data) {
      state.femaleFocusParam = data;
    },
    clearParam: function clearParam(state) {
      state.countriesParam = [];
      state.sectorsParam = [];
      state.providerTypesParam = [];
      state.capitalTypesParam = [];
    },
    toggleCapitalTypesParam: function toggleCapitalTypesParam(state, data) {
      var code = data.code;
      var i = state.capitalTypesParam.indexOf(code);

      if (i >= 0) {
        state.capitalTypesParam.splice(i, 1);
      } else {
        state.capitalTypesParam.push(code);
      }

      state.results = [];
    },
    toggleProviderTypesParam: function toggleProviderTypesParam(state, data) {
      var code = data.code;
      var i = state.providerTypesParam.indexOf(code);

      if (i >= 0) {
        state.providerTypesParam.splice(i, 1);
      } else {
        state.providerTypesParam.push(code);
      }

      state.results = [];
    },
    toggleCountriesParam: function toggleCountriesParam(state, data) {
      var code = data.code;
      var i = state.countriesParam.indexOf(code);

      if (i >= 0) {
        state.countriesParam.splice(i, 1);
      } else {
        state.countriesParam.push(code);
      }

      state.results = [];
    },
    toggleSectorsParam: function toggleSectorsParam(state, data) {
      var code = data.code;
      var i = state.sectorsParam.indexOf(code);

      if (i >= 0) {
        state.sectorsParam.splice(i, 1);
      } else {
        state.sectorsParam.push(code);
      }

      state.results = [];
    },
    setResults: function setResults(state, data) {
      state.results = data;
    },
    setResultsInPlace: function setResultsInPlace(state, data) {
      data.forEach(function (data_item) {
        var data_id = data_item.hasOwnProperty('id') ? data_item.id : data_item.provider_id;
        var provider_index = state.results.findIndex(function (state_item) {
          var state_id = state_item.hasOwnProperty('id') ? state_item.id : state_item.provider_id;
          return data_id == state_id;
        });
        state.results[provider_index] = data_item;
      });
    },
    setLoadingResults: function setLoadingResults(state, data) {
      state.loadingResults = data;
    },
    // pageination methods
    setResultsPerPage: function setResultsPerPage(state, resultsPerPage) {
      state.resultsPerPage = resultsPerPage;
    },
    setMaxResults: function setMaxResults(state, maxResults) {
      state.maxResults = maxResults;
    },
    nextPage: function nextPage(state) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var asdasd = arguments.length > 2 ? arguments[2] : undefined;

      if (state.range[0] + state.resultsPerPage * num < state.results.length) {
        state.range = state.range.map(function (bound) {
          return bound + state.resultsPerPage * num;
        });
      }
    },
    prevPage: function prevPage(state) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      if (state.range[1] - state.resultsPerPage * num > 0) {
        state.range = state.range.map(function (bound) {
          return bound - state.resultsPerPage * num;
        });
      }
    },
    setPage: function setPage(state) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (num * state.resultsPerPage < state.results.length && (num + 1) * state.resultsPerPage > 0) {
        state.range = [num * state.resultsPerPage, (num + 1) * state.resultsPerPage];
      }
    },
    appendResults: function appendResults(state) {
      var num = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : state.resultsPerPage;

      if (state.range[1] + num - state.range[0] > 1 && state.range[1] + num < state.results.length + state.resultsPerPage) {
        state.range = [state.range[0], state.range[1] + num];
      }
    }
  },
  actions: {
    fetchResults: function fetchResults(context) {
      context.getters.api.provider.search(context.getters.token, {
        capital_type: context.state.capitalTypesParam,
        provider_type: context.state.providerTypesParam,
        sector: context.state.sectorsParam,
        country: context.state.countriesParam,
        female_focus: context.state.femaleFocusParam == true ? [1] : [0],
        q: [ops.search_string == undefined ? '' : ops.search_string]
      }).then(function (results) {
        context.commit('setResults', r.data._items);
      })["catch"](function (err) {
        return errorHandler(err, context);
      });
    },
    search: function search(context) {
      var ops = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        search_string: '',
        embed: undefined
      };

      var searchParams = _filterEmpty({
        capital_type: context.state.capitalTypesParam,
        provider_type: context.state.providerTypesParam,
        sector: context.state.sectorsParam,
        country: context.state.countriesParam,
        female_focus: context.state.femaleFocusParam == true ? [1] : [0],
        q: [ops.search_string == undefined ? '' : ops.search_string]
      });

      context.commit('setLoadingResults', true);
      context.commit('setNumResults', 0);
      var errorEvent = false;
      var results = [];
      var i = 1;
      context.getters.api.provider.search(context.getters.token, searchParams, context.getters.resultsPerPage).then(
      /*#__PURE__*/
      function () {
        var _ref = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(r) {
          var response;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  context.commit('setResults', r.data._items);
                  context.commit('setNumResults', r.data._meta.total);

                case 2:
                  _context.next = 4;
                  return context.getters.api.provider.search(context.getters.token, searchParams, context.getters.maxResults, i)["catch"](function (error) {
                    errorEvent = true;
                    throw error;
                  }).then(function (r) {
                    if (!errorEvent) {
                      results.push.apply(results, _toConsumableArray(r.data._items));
                    }

                    i++;
                  });

                case 4:
                  response = _context.sent;

                case 5:
                  if (!errorEvent && results.length < context.getters.maxResults && results.length < r.data._meta.total) {
                    _context.next = 2;
                    break;
                  }

                case 6:
                  context.commit('setResults', results);
                  context.commit('setLoadingResults', false);
                  context.dispatch('fetchProvidersByIds', {
                    ids: results.map(function (provider) {
                      return provider['provider_id'];
                    }),
                    embed: ops.embed
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }())["catch"](function (err) {
        context.commit('setLoadingResults', false);
        return errorHandler(err, context);
      });
    },
    fetchProvidersByIds: function () {
      var _fetchProvidersByIds = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(context) {
        var ops,
            idBatch,
            _args2 = arguments;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                ops = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {
                  ids: undefined,
                  embed: undefined
                };
                idBatch = [];

              case 2:
                if (!(ops.ids.length > 0)) {
                  _context2.next = 8;
                  break;
                }

                idBatch = ops.ids.splice(0, 5);
                _context2.next = 6;
                return context.getters.api.provider.get(context.getters.token, idBatch, ops.embed).then(function (r) {
                  context.commit('setResultsInPlace', r.data._items);
                  return r;
                })["catch"](function (err) {
                  context.commit('setLoadingResults', false);
                  return errorHandler(err, context);
                });

              case 6:
                _context2.next = 2;
                break;

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function fetchProvidersByIds(_x2) {
        return _fetchProvidersByIds.apply(this, arguments);
      }

      return fetchProvidersByIds;
    }()
  }
};

function _filterEmpty(obj) {
  var new_obj = {};

  for (var key in obj) {
    if (obj[key].length != 0) {
      new_obj[key] = obj[key];
    }
  }

  return new_obj;
}

var _default = search;
exports["default"] = _default;


// WEBPACK FOOTER //
// ../capital-finder-vuex/lib/modules/searchResults.js